<template>
  <div>
    <el-col :span="24">
      <div>
        <div class="search-content">
          <el-col :span="24" class="toobar">
            <el-col :span="4">
              <el-date-picker size="small" style="width:215px;"
                              v-model="searchdatevalue"
                              type="daterange" :value-format="'yyyy-MM-dd'"
                              align="left" :unlink-panels="true"
                              range-separator="至" :clearable="false"
                              start-placeholder="开始日期"
                              end-placeholder="结束日期">
              </el-date-picker>
            </el-col>
            <el-col :span="4">
              <el-radio-group v-model="invoicesource" size="mini" @change="bindGrid">
                <el-radio-button label="" key="">全部</el-radio-button>
                <el-radio-button label="order" key="order">订单岗</el-radio-button>
                <el-radio-button label="store" key="store">仓库岗</el-radio-button>
              </el-radio-group>
            </el-col>
            <el-col :span="4">
              <el-select v-model="independentserial" filterable size="small">
                <el-option v-for="item in idd" :key="item.serialnum"
                           :label="item.dname"
                           :value="item.serialnum">
                </el-option>
              </el-select>
            </el-col>
            <el-col :span="12">
              <el-button type="primary" v-on:click="bindGrid" size="mini">搜索</el-button>
              <el-button size="small" plain @click="exportPdf('sale','销货单')">销货单明细</el-button>
              <el-button size="small" plain @click="exportPdf('tuihuo','退货单')">退货单明细</el-button>
              <el-button size="small" plain @click="exportPdf('buy','采购单')">采购单明细</el-button>
              <el-button size="small" plain @click="exportPdf('diaobo','调拨单')">调拨单明细</el-button>
              <el-button type="warning" @click="excelPort" size="mini">导出</el-button>
            </el-col>
          </el-col>
        </div>
        <el-table
          :data="tableData"
          :height="eltableheight"
          size="mini"
          border    show-summary :summary-method="getSummaries"
          style="width: 100%;">
          <el-table-column label="部门" align="left" header-align="center" width="130" fixed>
            <template slot-scope="scope">{{scope.row.dname}}</template>
          </el-table-column>
          <el-table-column label="人员" align="left" header-align="center" width="90" fixed>
            <template slot-scope="scope">{{scope.row.uname}}</template>
          </el-table-column>
          <el-table-column label="岗位" align="left" header-align="center" width="160" :show-overflow-tooltip="true">
            <template slot-scope="scope">{{scope.row.erpserial}}</template>
          </el-table-column>
          <el-table-column :label="item.name" v-for="item in coloum" :key="item.code" header-align="center" v-if="!invoicesource||invoicesource==item.type">
          <el-table-column label="订单量" align="right" header-align="center" :prop="item.code+'count'">
            <template slot-scope="scope">{{scope.row[item.code+'count']}}</template>
          </el-table-column>
          <el-table-column label="商品数" align="right" header-align="center" :prop="item.code+'number'">
            <template slot-scope="scope">{{scope.row[item.code+'number']}}</template>
          </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </el-col>
  </div>
</template>
<script>

  import {cangkuworkload, workload} from '@/api/set/csagreement';
  import {exportExcel} from '@/api/file'
  import {independentDept} from '@/api/set/dept';

  export default {
    name: 'Workload',
    data() {
      return {
        tableData: [],
        invoicesource:'',
        eltableheight:300,
        yearflag: '',//年份
        searchdatevalue:[],
        independentserial: 'all',
        coloum: [
          {name: '自主下单', code: 'zzxd',type:'order'},
          {name: '代客户下单', code: 'dkhxd',type:'order'},
          {name: '代客户退单', code: 'dkhtd',type:'order'},
          {name: "订单确认", code: 'ddqr',type:'order'},
          {name: "以销定采", code: 'yxdc',type:'order'},
          {name: "通知仓库", code: 'tzck',type:'order'},
          {name: '拣货人', code: 'jh',type:'store'},
          {name: '拣货审核人', code: 'jhsh',type:'store'},
          {name: "仓库发货", code: 'ckfh',type:'store'},
          {name: "以销定采出库", code: 'yxdcck',type:'store'},
          {name: "库存商品出库", code: 'kcspck',type:'store'},
          {name: "录入采购单", code: 'lrcgd',type:'store'},
          {name: "采购入库", code: 'cgrk',type:'store'},
          {name: "录入调拨单", code: 'lrdbd',type:'order'},
          {name: "调拨入库", code: 'dbrk',type:'store'},
          {name: "调拨出库", code: 'dbck',type:'store'},
          {name: "退货审核通过", code: 'thshtg',type:'store'},
          {name: "退货入库", code: 'thrk',type:'store'},
          {name: "退回供应商", code: 'thgys',type:'store'}
        ],
      }
    },
    props: {
      roletype: {
        default: "" //角色菜单信息， 取值：order 、 store ， 分别对应订单、仓库  等菜单角色
      }
    },
    methods: {
      getSummaries(param) {
        const {columns, data} = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (!column.property)
            return '';
          const values =data.map(item => item[column.property]);
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
        })
        for (let i = 0; i < sums.length; i++) {
          if (sums[i])
            sums[i] = this.$numeric(sums[i], 0)
        }
        return sums;
      },
      bindGrid() {//绑定列表
        this.tableData = []
        var startDate = new Date(this.searchdatevalue[0]);
        var endDate = new Date(this.searchdatevalue[1]);
        var preDate = endDate.getMonth() >= 4 ? new Date(endDate.getFullYear() + '-' + (endDate.getMonth() + 1 - 4) + '-' + endDate.getDate())
          : new Date((endDate.getFullYear() - 1) + '-' + (12 + endDate.getMonth() + 1 - 4) + '-' + endDate.getDate());
        if (startDate < preDate) {
          this.$message({
            message: '单次查询时间跨度最大为120天！',
            type: 'error'
          })
          return false;
        }

        workload({
          yearflag: '',
          begindate: (startDate.getFullYear()+'-'+(startDate.getMonth()+1)+'-'+startDate.getDate()) + " 0:00:00",
          enddate: (endDate.getFullYear()+'-'+(endDate.getMonth()+1)+'-'+endDate.getDate())  + ' 23:59:59',
          independentserial: this.independentserial
        }).then(response => {
          var data = response.data.obj
          var newData=[];
          for (var i in data) {
            var caseStep='';
            for(var j in this.coloum){
              if(this.coloum[j].name==data[i].casestepname){
                caseStep=this.coloum[j].code;
                break;
              }
            }
            if(caseStep=='')
              continue;

            var hasValue=false;
            for (let j in newData) {
              if (newData[j].uguid == data[i].uguid) {
                newData[j][caseStep+'number']=parseInt(data[i].totalnumber)
                newData[j][caseStep+'count']=parseInt(data[i].insub)
                hasValue=true;
                break;
              }
            }
            if(!hasValue){
              data[i][caseStep+'number']=parseInt(data[i].totalnumber)
              data[i][caseStep+'count']=parseInt(data[i].insub)
              newData.push(data[i])
            }
          }

          for (let i in newData) {
            newData[i]['ddqrnumber']=(newData[i]['yxdcnumber']>0?newData[i]['yxdcnumber']:0)+(newData[i]['tzcknumber']>0?newData[i]['tzcknumber']:0);
            newData[i]['ddqrcount']=(newData[i]['yxdccount']>0?newData[i]['yxdccount']:0)+(newData[i]['tzckcount']>0?newData[i]['tzckcount']:0);

            newData[i]['ckfhnumber']=(newData[i]['yxdccknumber']>0?newData[i]['yxdccknumber']:0)+(newData[i]['kcspcknumber']>0?newData[i]['kcspcknumber']:0);
            newData[i]['ckfhcount']=(newData[i]['yxdcckcount']>0?newData[i]['yxdcckcount']:0)+(newData[i]['kcspckcount']>0?newData[i]['kcspckcount']:0);
          }
          this.tableData=newData;
          var height= this.tableHeight(90);
          this.eltableheight =this.eltableheight== height?(height-1):height;
        }).catch((error) => {
          console.log(error)
        });
      },
      excelPort() {
        var startDate = new Date(this.searchdatevalue[0]);
        var endDate = new Date(this.searchdatevalue[1]);
        var name = (startDate.getFullYear()+'-'+(startDate.getMonth()+1)+'-'+startDate.getDate())+'~'+(endDate.getFullYear()+'-'+(endDate.getMonth()+1)+'-'+endDate.getDate()) + '工作量明细';
        let data = this.tableData;
        let header1 = [ "部门", "人员", "岗位", ];
        let column1 = ["dname", "uname", "erpserial"];
        for(let i in this.coloum){
          if(this.invoicesource&&!(this.invoicesource==this.coloum[i].type)){
            continue;
          }
          header1.push(this.coloum[i].name+"订单量");
          header1.push(this.coloum[i].name+"商品数");
          column1.push(this.coloum[i].code+"count");
          column1.push(this.coloum[i].code+"number");
        }
        this.$exportExcel(header1, column1, data, name);
      },
      //打印
      exportPdf(type, filename) {
        var startDate = new Date(this.searchdatevalue[0]);
        var endDate = new Date(this.searchdatevalue[1]);
        var preDate = endDate.getMonth() >= 4 ? new Date(endDate.getFullYear() + '-' + (endDate.getMonth() + 1 - 4) + '-' + endDate.getDate())
          : new Date((endDate.getFullYear() - 1) + '-' + (12 + endDate.getMonth() + 1 - 4) + '-' + endDate.getDate());
        if (startDate < preDate) {
          this.$message({
            message: '单次查询时间跨度最大为120天！',
            type: 'error'
          })
          return false;
        }
        var name = (startDate.getFullYear()+'-'+(startDate.getMonth()+1)+'-'+startDate.getDate())+'~'+(endDate.getFullYear()+'-'+(endDate.getMonth()+1)+'-'+endDate.getDate()) + filename
        var data = {
          type: type,//明细账数据
          begindate: (startDate.getFullYear()+'-'+(startDate.getMonth()+1)+'-'+startDate.getDate()) + " 0:00:00",
          enddate: (endDate.getFullYear()+'-'+(endDate.getMonth()+1)+'-'+endDate.getDate())  + ' 23:59:59',
          filename: name,
          businessType: 'extraWorkExcel',
        };
        exportExcel(data, name, false)
      },
    },

    mounted() {
      var end = new Date();//当天
      var year = end.getFullYear();
      var month = end.getMonth() + 1;
      this.searchdatevalue = [ year + '-' + month + '-1', year + '-' + month + '-' + end.getDate()];
      this.yearflag = '';

      independentDept().then(response => {
        this.idd = response.data.obj
        this.idd.unshift({serialnum: "all", dname: "全部"})
        this.bindGrid();
      })
    },
    components: {}
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/testorder/cstagreement/Workload.vue